import { Col, Flex, Row } from 'antd';

import { skillSetGameDetails } from './skillSetGameDetails';

// eslint-disable-next-line no-magic-numbers
const GAME_CARD_GUTTER: [number, number] = [20, 20];

function SkillSetInfoModalContent() {
  return (
    <>
      {/* Table of Contents */}
      {skillSetGameDetails.map((detail) => (
        <div key={detail.label}>
          <ul style={{ listStyleType: 'disc' }}>
            <li>
              <a href={`#${detail.label}`}>{detail.label}</a>
            </li>
          </ul>
        </div>
      ))}

      {/* Skill Set Sections */}
      {skillSetGameDetails.map((detail) => (
        <div key={detail.label}>
          <h4 className="fw-bold skillset-heading" id={detail.label}>
            {detail.label}
          </h4>
          <div className="skillset-content">
            <p className="fw-bold">{detail.text}</p>
            <Row gutter={GAME_CARD_GUTTER}>
              {detail.games.map((game, gameIndex) => (
                <Col key={game.gameName} span={24}>
                  <Flex className="card" gap="24px" align="center">
                    <Flex gap="14px" vertical>
                      <div>
                        <p className="fw-bold">
                          Game {gameIndex + 1}:{' '}
                          <span className="text-primary">{game.gameName}</span>
                        </p>
                        {game.gameDescriptions.map((item) => (
                          <p key={item} className="text-sm">
                            {item}
                          </p>
                        ))}
                      </div>
                      <p className="fw-bold">{game.challenge}</p>
                      <p>{game.rule}</p>
                      <div>
                        <p className="fw-bold">Example:</p>
                        {game.example.map((item) => (
                          <p key={item}>{item}</p>
                        ))}
                      </div>
                    </Flex>
                    <img
                      className="card-image"
                      src={game.image}
                      alt="Modal Game img"
                    />
                  </Flex>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      ))}
    </>
  );
}

export { SkillSetInfoModalContent };
